import { ref } from 'vue';
import { useToast } from '@/composables/use-toast';
import { getFriendlyErrorMessage } from '@/utils/errorUtils.js';
import { getPublicLlms } from '@/services/modelRunService';

export function useRunWithModels() {
  const { addToast } = useToast();
  const isOpening = ref(false);

  const ensureCatalogAvailable = async () => {
    const llms = await getPublicLlms();
    const models = Array.isArray(llms) ? llms : [];
    if (!models.length) {
      addToast('No self-serve models available yet.', 'error');
      return false;
    }
    return true;
  };

  const openWithFeedback = async ({
    errorFallback = 'Failed to open model benchmark. Please try again.',
    action,
  }) => {
    if (isOpening.value) return false;

    isOpening.value = true;

    try {
      const result = await action({ addToast, ensureCatalogAvailable });
      return Boolean(result);
    } catch (error) {
      addToast(getFriendlyErrorMessage(error, errorFallback), 'error');
      return false;
    } finally {
      isOpening.value = false;
    }
  };

  return {
    isOpening,
    addToast,
    ensureCatalogAvailable,
    openWithFeedback,
  };
}
